/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { Button, Dialog, DialogContent, DialogTitle, LinearProgress, TextField } from '@mui/material';
import Grid from '@mui/material/Grid';
import { withStyles } from '@mui/styles';
import CloseIcon from '@mui/icons-material/Close';
import copy from 'copy-to-clipboard';
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { navigationButtonStyle } from '../common/common';
import { uploadServiceBulletinEndPoint } from '../common/constants';
import { loadFromLocalStorage } from '../common/localStorage';
import logo from '../images/blueLogo.svg';
import icAdd from '../images/ic-add.svg';
import { actionCreators } from '../store/UploadBulletin';
import DragDrop from './DragDrop';
import './styles.css';

interface Props {
    classes?: any;
    isEdit?: boolean;
    uploadDialogOpen: boolean;
    handleUploadDialogClick: Function;
    clearAll: Function;
    selectedPdf: any;
    UpdateSelectedPdf: Function;
    handleBulletinInformationChange: Function;
    fileName: any;
    UpdateFileName: Function;
    title?: string;
}
interface State {
    isFormSubmitted: boolean
    isUploading: boolean
    isSuccess: boolean
    isFailure: boolean
    bulletinURL: any,
    title: any,

}
const styles = () => ({
    input: {
        height: 0,
        width: 300,
        backgroundColor: '#fff'
    },
    dateInput: {
        height: 9,
        width: 244,
        backgroundColor: '#fff'
    },
    selectInput: {
        width: 328,
        height: 40,
        backgroundColor: '#fff'
    },
    disabledOption: {
        color: 'gray'
    },
    navigationButton: navigationButtonStyle
})
class UploadBulletin extends React.Component<Props, State> {
    state = {
        isFormSubmitted: false,
        isUploading: false,
        isSuccess: false,
        isFailure: false,
        bulletinURL: '',
        title: 'Service Bulletin Upload'
    };
    handleClickOpen = () => {
        this.state.isSuccess = false;
        this.props.handleUploadDialogClick(true);
    };
    handleClose = () => {

        this.setState({ isFormSubmitted: false });
        this.props.clearAll();
        this.props.handleUploadDialogClick(false);
    };
    onDrop = async (selectedPdf: any, fileName: any) => {
        await this.props.UpdateFileName(`${fileName}`);
        this.props.UpdateSelectedPdf(selectedPdf);
    };
    handleChange = (event: any) => {
        this.props.handleBulletinInformationChange(event);
    };
    handleCopy = (event: any) => {
        if (this.state.bulletinURL !== undefined) {
            copy(this.state.bulletinURL);

        }
    };
    handleDone = (event: any) => {
        window.location.reload();
    };
    handleUpload = async () => {

        const uploadRequest = new FormData();
        uploadRequest.append('filename', `${this.props.fileName}`);
        uploadRequest.append('formfile', this.props.selectedPdf);

        const token: string = loadFromLocalStorage('AuthToken');
        const encodedToken = 'Bearer ' + token;
        const headerDict: any = {
            'Authorization': encodedToken,
        };
        this.setState({ isFormSubmitted: true, isUploading: true });
        fetch(uploadServiceBulletinEndPoint, {
            headers: new Headers(headerDict),
            body: uploadRequest,
            method: 'POST'
        })
            .then(async (response: any) => {
                const data = await response.json();
                this.setState({ isUploading: false });
                const responseData = response.status;
                if (response.status === 201 || response.status === 200) {

                    console.log(data);
                    this.setState({ isSuccess: true });
                    this.setState({ bulletinURL: data.bulletinURL });
                    this.setState({ title: 'Copy URL' });
                }
                else {
                    this.setState({ isFailure: true }, () => {
                        setTimeout(() => {
                            this.setState({
                                isFormSubmitted: false, isFailure: false
                            });
                        }, 5000);
                    });
                }
            });
    };

    static defaultProps = {
        handleUploadDialogClick: () => { },
        clearAll: () => { },
        UpdateSelectedPdf: () => { },
        UpdateFileName: () => { },
        handleBulletinInformationChange: () => { },
        uploadDialogOpen: false
    };

    render() {
        const { isFormSubmitted, isUploading, isSuccess, isFailure, title } = this.state;
        const { classes, isEdit, uploadDialogOpen, } = this.props;
        let isDisabled = true, ispartnumberfilled = true;
        if (this.props.selectedPdf === undefined) {

            isDisabled = true;
        }
        else {
            isDisabled = false;
        }
        return (
            <div>
                {!isEdit && <Button id="upload-button" onClick={this.handleClickOpen}>
                    <Grid container justifyContent="space-evenly">
                        <img src={icAdd}
                            className="ic_add" />
                        <span className="uploadButtonText">{this.props.title}</span>
                    </Grid>
                </Button>
                }
                <Dialog
                    fullScreen
                    className="UploadDialog"
                    open={uploadDialogOpen}
                    onClose={this.handleClose}
                >
                    <DialogTitle className="dialogTitle">
                        <Grid container justifyContent="space-between">
                            <span>
                                <img src={logo} />
                                <span className="boldFont uploadTitle">{title}</span>
                            </span>

                            {(!isUploading) &&
                                <CloseIcon onClick={this.handleClose} style={{ cursor: 'pointer' }} />}

                        </Grid>
                    </DialogTitle>
                    <DialogContent className="uploadDialogContent">
                        {!isFormSubmitted &&
                            <Grid container className="uploadGrid">
                                <Grid className="dragdrop">
                                    <DragDrop onDrop={this.onDrop} selectedPdf={this.props.selectedPdf} />
                                </Grid>
                                <div className="classificationGrid">
                                    <Grid className="classificationGridTitle">1. Upload the Bulletin file</Grid>
                                    <Grid container justifyContent="flex-end" className="navigatiobuttonGrid bulletinInformationButton">
                                        <Button className={classes.navigationButton} disabled={isDisabled} onClick={this.handleUpload}>Upload</Button>
                                    </Grid>
                                </div>

                            </Grid>

                        }

                        {isUploading &&
                            <Grid className="uploadDialogMessages">
                                <Grid container justifyContent="center">
                                    Uploading...
                                </Grid>
                                <Grid>
                                    <LinearProgress className="uploadprogress" />
                                </Grid>
                            </Grid>
                        }
                        {isSuccess &&
                            <Grid>
                                <Grid container justifyContent="center">
                                    <Grid>
                                        <Grid container className="classificationGrid ">
                                            <Grid className="classificationGridTitle">2. Upload Link</Grid>
                                            <Grid container className="manualInformationContent">
                                                <Grid>
                                                    <TextField
                                                        name="bulletinURL"
                                                        value={this.state.bulletinURL}
                                                        variant="outlined"
                                                        InputProps={{ classes: { input: classes.input } }}
                                                    />
                                                </Grid>
                                                <Button className={classes.navigationButton} onClick={this.handleCopy}>Copy the Link</Button>
                                            </Grid>

                                        </Grid>
                                        <Grid container justifyContent="flex-end" className="bulletinclassificationGrid">
                                            <Button className={classes.navigationButton} onClick={this.handleDone}>Done</Button>
                                        </Grid>
                                    </Grid>

                                </Grid> </Grid>
                        }
                        {isFailure &&
                            <Grid className="uploadDialogMessages" container justifyContent="center">
                                There was an error while uploading. Please try again later...
                            </Grid>
                        }

                    </DialogContent>
                </Dialog>
            </div>

        );
    }
}
const mapStateToProps = (state: any) => ({
    uploadDialogOpen: state.uploadBulletin.uploadDialogOpen,
    isEdit: state.uploadBulletin.isEdit,
    selectedPdf: state.uploadBulletin.selectedPdf,
    fileName: state.uploadBulletin.fileName
});

const mapDispatchtoProps = (dispatch: any) =>
    bindActionCreators(actionCreators, dispatch);

interface ExtraProps {
    title?: string;
}

// -------------------- Export Connected Component --------------------
export default connect<ReturnType<typeof mapStateToProps>, typeof mapDispatchtoProps, ExtraProps>(
    mapStateToProps,
    mapDispatchtoProps
)(withStyles(styles)(UploadBulletin));
